import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { buildApiRoute } from "legacy/helpers.es6"
import React from "react"
import SimpleReactValidator from "simple-react-validator"

import Modal from "src/components/Modal"

// Note: jQuery ($) is loaded globally

class AuthSignUpKiosk extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      fname: "",
      lname: "",
      email: "",
      password: "",
      checkbox: false,
      validationMessage: null,
      processing: false,
      success: false,
    }
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    })
    this.submit = this.submit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.checkEmail = this.checkEmail.bind(this)
    this.postToSignUp = this.postToSignUp.bind(this)
    this.renderSuccessModal = this.renderSuccessModal.bind(this)
  }

  handleInputChange(event) {
    this.validator.hideMessages()
    const name = event.target.name
    const val =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value
    this.setState({ [name]: val })
  }

  submit() {
    if (this.validator.allValid()) {
      this.setState({ processing: true })
      this.setState({ validationMessage: "" })
      this.checkEmail()
    } else {
      this.validator.showMessages()
    }
  }

  checkEmail() {
    $.post(
      buildApiRoute("validate/email"),
      { email: this.state.email.trim() },
      () => {
        this.postToSignUp()
      }
    ).fail((data) => {
      if (data.status === 409) {
        this.setState({
          validationMessage: "You seem to already be registered with us!",
          processing: false,
        })
      } else {
        this.setState({
          validationMessage: "An error has occurred. Please try again",
          processing: false,
        })
      }
    })
  }

  postToSignUp() {
    $.post(
      "/users",
      {
        "user[email]": this.state.email.trim(),
        "user[first_name]": this.state.fname,
        "user[last_name]": this.state.lname,
        "user[password]": this.state.password,
        source_medium: "kiosk",
      },
      () => {
        this.setState({
          fname: "",
          lname: "",
          email: "",
          password: "",
          checkbox: false,
          validationMessage: null,
          processing: false,
          success: true,
        })
        this.validator.purgeFields()
        setTimeout(() => {
          this.handleCloseModal()
        }, 5000)
      },
      "json"
    ).fail((jqXHR) => {
      if (jqXHR.status === "422") {
        this.setState({
          validationMessage: "You seem to already be registered with us!",
          processing: false,
        })
      } else {
        this.setState({
          validationMessage: "An error has occurred. Please try again",
          processing: false,
        })
      }
    })
  }

  handleCloseModal() {
    this.setState({ success: false })
  }

  renderSuccessModal() {
    return (
      <Modal isOpen={this.state.success} onClose={this.handleCloseModal}>
        <Modal.Body>
          <div className="mt-10 text-center">
            <i className="fa-solid fa-circle-check text-success text-8xl" />
            <p className="h2 text-success">Success!</p>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

  render() {
    return (
      <div className="text-2xl">
        <div className="flex justify-between">
          <div className="mr-1 w-1/2 text-2xl">
            <FormGroup
              label="First name"
              name="fname"
              value={this.state.fname}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "first_name",
                this.state.fname,
                "required"
              )}
            />
          </div>
          <div className="ml-1 w-1/2 text-2xl">
            <FormGroup
              label="Last name"
              name="lname"
              value={this.state.lname}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "last_name",
                this.state.lname,
                "required"
              )}
            />
          </div>
        </div>
        <div className="text-2xl">
          <FormGroup
            label="Email"
            name="email"
            value={this.state.email}
            onChange={this.handleInputChange}
            validation={this.validator.message(
              "email",
              this.state.email,
              "required|email"
            )}
          />
        </div>
        <div className="text-2xl">
          <FormGroup
            inputType="password"
            label="Password"
            name="password"
            value={this.state.password}
            onChange={this.handleInputChange}
            validation={this.validator.message(
              "password",
              this.state.password,
              "required|min:6"
            )}
          />
        </div>
        <div className="checkbox bs-mb-4 mt-10">
          <label style={{ display: "inline" }}>
            <input
              className="mt-2 h-4 w-4"
              type="checkbox"
              name="checkbox"
              checked={this.state.checkbox}
              onChange={this.handleInputChange}
            />
            &nbsp;I agree to Dockwa&#8217;s&nbsp;
            <a
              href={"/about-us/terms-of-service"}
              target="_blank"
              rel="noopener noreferrer"
              className="plain-link"
            >
              Terms and Conditions
            </a>
            &nbsp;and&nbsp;
            <a
              href={"/privacy"}
              target="_blank"
              rel="noopener noreferrer"
              className="plain-link"
            >
              Privacy Policy.
            </a>
            {this.validator.message(
              "checkbox",
              this.state.checkbox,
              "accepted"
            )}
          </label>
        </div>
        <NextButton
          processing={this.state.processing}
          disabled={this.state.success}
          click={this.submit}
          text="Sign Up"
          processingText="Creating Account..."
          btnClass="w-full btn-primary"
        />
        {this.state.success && this.renderSuccessModal()}
      </div>
    )
  }
}

export default AuthSignUpKiosk
